(function() {
    angular
        .module("devicesModule")
        .config(devicesRouter)

    devicesRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function devicesRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){

        $stateProvider
            .state("devices", {
                url: "/devices",
                templateUrl: "app/components/devices/devices.view.html",
                controller : "DevicesController"
            })
            .state("customer-devices", {
                url: "/devices/customer-id/:customer_id",
                templateUrl: "app/components/devices/devices.view.html",
                controller : "DevicesController"
            })

            .state("device-message-board", {
                url: "/message-board/id/:message_board_id",
                templateUrl: "app/components/devices/message-board/message-board.view.html",
                controller : "DeviceMessageBoardController"
            })

            .state("device-message-board-new", {
                url: "/message-boards/new/:type",
                templateUrl: "app/components/devices/message-board/new.view.html",
                controller : "DeviceMessageBoardNewController"
            })

            .state("device-message-board.details", {
                url: "/details",
                views: {
                    "device_details": {
                        templateUrl: "app/components/devices/message-board/details.view.html",
                        controller : "DeviceMessageBoardDetailsController"
                    }
                }
            })
            .state("device-message-board.map", {
                url: "/map",
                views: {
                    "device_details": {
                        templateUrl: "app/components/devices/message-board/map.view.html",
                        controller : "DeviceMessageBoardMapController"
                    }
                }
            })

            .state("device-message-board.history", {
                url: "/history",
                abstract: true,
                views: {
                    "device_details": {
                        templateUrl: "app/components/devices/message-board/history/history.view.html",
                        controller : "DeviceMessageBoardHistoryController"
                    }
                }
            })

            .state("device-message-board.history.all", {
                url: "/all",
                views: {
                    "history": {
                        templateUrl: "app/components/devices/message-board/history/all.view.html",
                        controller : "DeviceMessageBoardHistoryAllController"
                    }
                }
            })
            .state("device-message-board.history.telemetry", {
                url: "/telemetry",
                views: {
                    "history": {
                        templateUrl: "app/components/devices/message-board/history/telemetry.view.html",
                        controller : "DeviceMessageBoardHistoryTelemetryController"
                    }
                }
            })

            .state("device-message-board.history.alerts", {
                url: "/alerts",
                views: {
                    "history": {
                        templateUrl: "app/components/devices/message-board/history/alerts.view.html",
                        controller : "DeviceMessageBoardHistoryAlertsController"
                    }
                }
            })

            .state("device-message-board.schedule", {
                url: "/schedule",
                views: {
                    "device_details": {
                        templateUrl: "app/components/devices/message-board/schedule.view.html",
                        controller : "DeviceMessageBoardScheduleController"
                    }
                }
            })

            .state("device-message-board.stored_messages", {
                url: "/stored-messages",
                views: {
                    "device_details": {
                        templateUrl: "app/components/devices/message-board/stored-messages.view.html",
                        controller : "DeviceMessageBoardStoredMessagesController"
                    }
                }
            })

            .state("device-tracker", {
                url: "/tracker/id/:tracker_id",
                templateUrl: "app/components/devices/tracker/tracker.view.html",
                controller : "DeviceTrackerController"
            })

            .state("device-tracker.details", {
                url: "/details",
                views: {
                    "device_details": {
                        templateUrl: "app/components/devices/tracker/details.view.html",
                        controller : "DeviceTrackerDetailsController"
                    }
                }
            })

            .state("device-tracker.history", {
                url: "/history",
                abstract: true,
                views: {
                    "device_details": {
                        templateUrl: "app/components/devices/tracker/history/history.view.html",
                        controller : "DeviceTrackerHistoryController"
                    }
                }
            })

            .state("device-tracker.history.all", {
                url: "/all",
                views: {
                    "history": {
                        templateUrl: "app/components/devices/tracker/history/all.view.html",
                        controller : "DeviceTrackerHistoryAllController"
                    }
                }
            })
            .state("device-tracker.history.telemetry", {
                url: "/telemetry",
                views: {
                    "history": {
                        templateUrl: "app/components/devices/tracker/history/telemetry.view.html",
                        controller : "DeviceTrackerHistoryTelemetryController"
                    }
                }
            })

            .state("device-tracker.history.alerts", {
                url: "/alerts",
                views: {
                    "history": {
                        templateUrl: "app/components/devices/tracker/history/alerts.view.html",
                        controller : "DeviceTrackerHistoryAlertsController"
                    }
                }
            })

            $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
